import { AppEntityID } from "~/common/enums";
import { ensureLastSlash } from "~/common/utils/ensureLastSlash";

const services = {
    forms: `${ep.appRoot}services/forms`,
    roles: `${ep.appRoot}services/roles`,
    systemLists: `${ep.appRoot}services/systemlists/api`,
    rateCards: `${ep.appRoot}services/ratecards/api`,
    messages: `${ep.appRoot}services/messages/api`,
    reports: `${ep.appRoot}services/reports`,
    resources: `${ep.appRoot}resources/api`,
    customers: `${ep.appRoot}services/customers`,
    projects: `${ep.appRoot}services/projects`,
    portfolios: `${ep.appRoot}services/portfolios`,
    tasks: `${ep.appRoot}tasks/api`,
    options: `${ep.appRoot}services/options`,
    presets: `${ep.appRoot}services/presets`,
    usermanagement: {
        roles: `${ep.appRoot}usermanagement/roles`,
        permissions: `${ep.appRoot}usermanagement/userpermissions`,
        users: `${ep.appRoot}usermanagement/users`,
        teams: `${ep.appRoot}usermanagement/teams`,
        skills: `${ep.appRoot}usermanagement/skills`,
    },
    external: `${ep.appRoot}externalintegrations`,
    notifications: `${ep.appRoot}notifications/api`,
    vacations: `${ep.appRoot}services/vacations/api`,
    approvals: `${ep.appRoot}approvals/api`,
    timelogs: `${ep.appRoot}services/timelogs/api`,
    licenses: `${ep.appRoot}services/licenses/api`,
    finances: `${ep.appRoot}finances/api`,
    invoices: `${ep.appRoot}finances/api/invoices`,
    taxRates: `${ep.appRoot}finances/api/taxrates`,
    invoiceOptions: `${ep.appRoot}finances/api/invoiceOptions`,
    attachments: `${ep.appRoot}attachments`,
    roadmap: `${ep.appRoot}roadmap/api`,
    archive: `${ep.appRoot}archive/api`,
    ai: `${ep.appRoot}services/ai/api`,
    customization: `${ep.appRoot}customization/api`,
    spaces:`${ep.appRoot}services/spaces/api`,
    takedaCustomizations:`${ep.appRoot}takedaCustomizations/api`,
    quickbooks: `${ep.appRoot}quickbooks-integrations/api/v1`,
};

export const appUrls = {
    common: {
        help: "https://help.birdviewpsa.com",
        recommendUs: "https://birdviewpsa.com/referral-program/",
        getPasswordPolicyData: ep.appRoot + "Common/GetPasswordPolicyData",
        getOauthToken: ep.appRoot + "Common/getOauthToken",
        importEntities: `${ep.appRoot}Common/ImportEntities`,
        logout: `${ep.appRoot}Common/Logout`,
        accountsControl: "https://portal.easyprojects.net",
        updateTrialUrl: (accountName, licensePlan) => {
            return `${appUrls.common.accountsControl}/subscription/expired?alias=${accountName}&licensePlan=${licensePlan}`;
        },
        getAvatarsCssMap: `${ep.appRoot}Common/GetAvatarsCssMap`,
        automationLearnMore: "https://birdviewpsa.com/integrations/workflow-automation/?account=trial",
    },
    birdview: {
        base: "https://www.birdviewpsa.com",
        hostingAgreement: "https://www.easyprojects.net/company/hosting-agreement/?p=bv",
        hosting_space: "https://www.easyprojects.net/company/hosting-space/?p=bv",
        hostedPricing: "https://www.easyprojects.net/birdview-psa/hosted-pricing-page/#buy",
        supportEmail: "support@birdviewpsa.com",
    },
    easyprojects: {
        base: "https://www.easyprojects.net",
        hostingAgreement: "https://www.easyprojects.net/company/hosting-agreement",
        hosting_space: "https://www.easyprojects.net/company/hosting-space",
        hostedPricing: "https://www.easyprojects.net/hosted-pricing-page/#buy"
    },
    projectThumbnail: {
        loadVisibility: `${ep.appRoot}projectthumbnail/api/loadvisibility`,
        setVisibility: `${ep.appRoot}projectthumbnail/api/setvisibility`,
        getProjectImageUrl: (projectId, customField, lastModificationDate) =>
            `${ep.appRoot}projectthumbnail/api/get/${projectId}?customField=${customField}&lastModificationDate=${lastModificationDate}`,
    },
    image: {
        getAvatar: `${ep.appRoot}Image/UserAvatar`
    },
    filters: {
        saveCurrentFilter: `${ep.appRoot}Filter/SaveCurrentConditions`,
        getQuickFilters: `${ep.appRoot}Filter/QuickFilter`,
        getAllCustomers: `${ep.appRoot}Filter/GetAllCustomers`,
        getAllProjects: `${ep.appRoot}Filter/GetAllProjects`,
        getAllPeople: `${ep.appRoot}Filter/GetAllPeople`,
        getAllPortfolios: `${ep.appRoot}Filter/GetAllPortfolios`,
        getHoursConditions: `${ep.appRoot}Filter/GetHoursConditions`,
        getProgressConditions: `${ep.appRoot}Filter/GetProgressConditions`,
        getMoneyConditions: `${ep.appRoot}Filter/GetMoneyConditions`,
        getCategoriesConditions: `${ep.appRoot}Filter/GetCategoryConditions`,
        getActivityTypesConditions: `${ep.appRoot}Filter/GetActivityTypeConditions`,
        getPriorityConditions: `${ep.appRoot}Filter/GetPriorityConditions`,
        getHealthConditions: `${ep.appRoot}Filter/GetHealthConditions`,
        getCustomFields: `${ep.appRoot}Filter/GetCustomFieldConditions`,
        getDateConditions : `${ep.appRoot}Filter/GetDateConditions`,
        getActivityStatusConditions: `${ep.appRoot}Filter/GetActivityStatusConditions`,
        getProjectStatusConditions: `${ep.appRoot}Filter/GetProjectStatusConditions`,
        getFollowByMeConditions: `${ep.appRoot}Filter/GetFollowByMeCondition`,
        TagIconsBaseUrl: `${ep.appRoot}Content/Styles/EasyProjects/Default/filter-images/group-icons`,
        GroupIconsBaseUrl: `${ep.appRoot}Content/Styles/EasyProjects/Default/filter-images/group-icons`,
        getFilterManagerModel: `${ep.appRoot}Filter/GetFilterManagerModel`,
    },
    activityList: {
        importFromMsProject: ep.appRoot + "ProjectImport.aspx?eplnk=1&modal=1",
        updateKanbanColumns: ep.appRoot + "ActivityCenter/UpdateKanbanColumns",
        assigmentByUserId: () => (ensureLastSlash(ep.uiAppRoot || ep.appRoot) + "activities?FilterAssignedTo={0}"),
        getHierarchy: ep.appRoot + "ActivityCenter/GetHierarchy",
        getProjectHierarchies: ep.appRoot + "ActivityCenter/GetProjectHierarchies",
        saveCustomization: ep.appRoot + "ActivityCenter/SaveCustomization",
        saveSorting: ep.appRoot + "ActivityCenter/SaveSorting",
        saveListViewType: ep.appRoot + "ActivityCenter/SaveListViewType",
        saveGanttWidth: ep.appRoot + "ActivityCenter/SaveGanttWidth",
        saveGanttZoomLevel: ep.appRoot + "ActivityCenter/SaveGanttZoomLevel",
        preloadGanttData: ep.appRoot + "ActivityCenter/PreloadGanttData",
        createTaskUrl: ep.appRoot + "ActivityCenter/CreateTask",
        createProjectUrl: ep.appRoot + "ActivityCenter/CreateProject",
        createTaskSimpleUrl: ep.appRoot + "ActivityCenter/CreateTaskSimple",
        createProjectApiUrl: ep.appRoot + "api/v1/projects",
        exportProjects: ep.appRoot + "ActivityCenter/ExportProjects",
        exportActivities: ep.appRoot + "ActivityCenter/ExportActivities",
        getActivityListModel: `${ep.appRoot}ActivityCenter/GetActivityListModel`,
    },
    activityListBatchOperations: {
        getChangeOperationData: ep.appRoot + "BatchOperations/GetChangeOperationData",
        changeActivitiesSimpleProperties: ep.appRoot + "BatchOperations/ChangeActivitiesSimpleProperties",
        changeProjectsSimpleProperties: ep.appRoot + "BatchOperations/ChangeProjectsSimpleProperties",
        deleteProjects: ep.appRoot + "BatchOperations/DeleteProjects",
        deleteActivities: ep.appRoot + "BatchOperations/DeleteActivities",
        changeProjectsMembers: ep.appRoot + "BatchOperations/ChangeProjectsMembers",
        changeActivitiesAssignees: ep.appRoot + "BatchOperations/ChangeActivitiesAssignees",
        changeActivitiesDates: ep.appRoot + "BatchOperations/ChangeActivitiesDates",
        duplicateProjects: ep.appRoot + "BatchOperations/DuplicateProjects",
        duplicateActivities: ep.appRoot + "BatchOperations/DuplicateActivities",
        getActivitiesDeleteInfo: ep.appRoot + "BatchOperations/GetActivitiesDeleteInfo",
        getProjectsDeleteInfo: ep.appRoot + "BatchOperations/GetProjectsDeleteInfo",
    },
    messageBoard: {
        updateFilterState: ep.appRoot + "MessageBoard/UpdateFilterState",
        updateVisitTime: `${services.messages}/updatevisittime`,
        getMessageBoardData: ep.appRoot + "MessageBoard/GetMessageBoardData",
        postMessage: ep.appRoot + "MessageBoard/PostMessage",
        getNotificationRecipients: `${services.messages}/getRecipients`,
        getApprovers: ep.appRoot + "Approval/GetAvailableApprovers",
        editMessage: ep.appRoot + "MessageBoard/EditMessage",
        deletePost: ep.appRoot + "MessageBoard/DeletePost",
        approve: ep.appRoot + "Approval/MarkAsApproved",
        reject: ep.appRoot + "Approval/MarkAsRejected",
        approvalUndo: ep.appRoot + "Approval/Undo",
        getMentions: ep.appRoot + "MessageBoard/GetAvailableMentions",
    },
    inlineTimelogs: {
        getTimelogs: ep.appRoot + "InlineTimelogs/GetTimelogs",
        showPreviousWeek: ep.appRoot + "InlineTimelogs/ShowPreviousWeek",
        showNextWeek: ep.appRoot + "InlineTimelogs/ShowNextWeek",
    },
    taskDetails: {
        getDetails: ep.appRoot + "TaskDetails/GetDetails",
        setIsMilestone: ep.appRoot + "InlineEdit/SetIsMilestoneForTask",
        changeName: ep.appRoot + "InlineEdit/ChangeActivityName",
        saveEstimatedHours: ep.appRoot + "InlineEdit/ChangeActivityEstimatedHours",
        saveHoursLeft: ep.appRoot + "InlineEdit/ChangeActivityHoursLeft",
        changeTaskType: ep.appRoot + "InlineEdit/ChangeTaskType",
        saveDescription: ep.appRoot + "InlineEdit/ChangeActivityDescription",
        saveCustomField: ep.appRoot + "InlineEdit/ChangeCustomFields",
        saveEndDate: ep.appRoot + "InlineEdit/ChangeEndDate",
        saveActualCompletionDate: ep.appRoot + "InlineEdit/ChangeActivityActualCompletionDate",
        saveBudget: ep.appRoot + "InlineEdit/ChangeActivityBudget",
        changeProject: ep.appRoot + "InlineEdit/ChangeActivityProject",
        changeParent: ep.appRoot + "InlineEdit/ChangeParent",
        getPossibleProjectsForMoving: `${services.tasks}/getPossibleProjectsForMoving`,
        loadParentTasksList: ep.appRoot + "TaskDetails/ParentTasksList",
        getDeleteInfo: ep.appRoot + "TaskDetails/GetDeleteInfo",
        deleteActivity: ep.appRoot + "InlineEdit/DeleteActivity",
        loadBillingsSettings: ep.appRoot + "TaskDetails/GetBillingSettings",
        saveBillingSettings: ep.appRoot + "InlineEdit/SaveBillingSettings",
        getRepeatSetting: ep.appRoot + "TaskDetails/GetRepeatSetting",
        repeat: ep.appRoot + "BatchOperations/Repeat",
        deleteRepeat: ep.appRoot + "BatchOperations/DeleteRepeatTasks",
        prolongRepeatTask: ep.appRoot + "BatchOperations/ProlongRepeatTask",
        setIsFollowedByMe:ep.appRoot + "InlineEdit/SetIsFollowedByMe",
        saveFollowers:ep.appRoot + "InlineEdit/SaveFollowers",
        onTaskVisited: `${services.tasks}/onTaskVisited`,
    },
    projectDetails: {
        getDetails: ep.appRoot + "ProjectDetails/GetDetails",
        changeName: ep.appRoot + "InlineEdit/ChangeProjectName",
        saveEstimatedHours: ep.appRoot + "InlineEdit/ChangeProjectEstimatedHours",
        saveDescription: ep.appRoot + "InlineEdit/ChangeProjectDescription",
        saveCustomField: ep.appRoot + "InlineEdit/ChangeCustomFields",
        saveEndDate: ep.appRoot + "InlineEdit/ChangeEndDate",
        saveBudget: ep.appRoot + "InlineEdit/ChangeProjectBudget",
        saveTotalBudget: ep.appRoot + "InlineEdit/ChangeProjectTotalBudget",
        changeMembers: ep.appRoot + "InlineEdit/ChangeProjectMembers",
        saveAutoAssignees: ep.appRoot + "ProjectDetails/SaveAutoAssigned",
        /**
         * @obsolete use project.getProjectMemberPermissions instead
         */
        getMemberPermissions: ep.appRoot + "ProjectDetails/GetPMPermissions",
        saveMemberPermissions: ep.appRoot + "InlineEdit/SaveProjectMemberPermissions",
        exportToMsProject: ep.appRoot + "ProjectDetails/ExportToMsProject",
        getDeleteInfo: ep.appRoot + "ProjectDetails/GetDeleteInfo",
        deleteProject: ep.appRoot + "InlineEdit/DeleteProject",
        refreshItem: ep.appRoot + "InlineEdit/RefreshItem",
        refreshHierarchy: ep.appRoot + "InlineEdit/RefreshHierarchy",
        getMembersList: ep.appRoot + "ProjectDetails/GetMembersList",
        captureBaseline: ep.appRoot + "ProjectDetails/CaptureBaseline",
        changeBillingSettings: ep.appRoot + "InlineEdit/ChangeBillingSettings",
    },
    assigneesList: {
        getTaskAssigneeModel: ep.appRoot + "References/GetEditTaskResourcesModel",
        getAssignees: ep.appRoot + "References/GetEditAssigneesModel",
        getAvailableHours: ep.appRoot + "References/GetAvailableHours",
        setWorkIsDoneForAssignee: ep.appRoot + "InlineEdit/SetWorkIsDoneForAssignee",
        updateDistributeHours: ep.appRoot + "References/UpdateDistributeHours",
    },
    preset: {
        getCurrent: `${services.presets}/api/getCurrent`,
        getAll: `${services.presets}/api/getAll`,
        getAllShared: `${services.presets}/api/getAllShared`,
        saveAs: `${services.presets}/api/saveas`,
        setCurrent: `${services.presets}/api/setCurrent`,
        edit: `${services.presets}/api/edit`,
        update: `${services.presets}/api/update`,
        updateVisibility: `${services.presets}/api/updateVisibility`,
        get: `${services.presets}/api/v2/get`,
        updateSharing:`${services.presets}/api/updateSharing`,
        delete:`${services.presets}/api/delete`,
        updateName:`${services.presets}/api/updateName`,
    },
    approval: {
        getMenuState: ep.appRoot + "Approval/GetMenuState",
        getMenuItems: ep.appRoot + "Approval/GetMenuItems"
    },
    task: {
        getTaskName: ep.appRoot + "References/GetTaskName",
        getEditFollowersModel: ep.appRoot + "TaskDetails/GetEditFollowersModel",
        getVisibleTaskNames: `${services.tasks}/getVisibleTaskNames`,
        getFollowers: `${services.tasks}/followers`,
        getIsFollowedByMe: `${services.tasks}/isFollowedByMe`,
        getBillingSettings: `${services.tasks}/getBillingSettings`,
        getHierarchy: `${services.tasks}/getHierarchy`,
        getFullHierarchy: `${services.tasks}/getFullHierarchy}`,
        getFullHierarchyCsv: `${services.tasks}/ActivityList/getFullHierarchy/csv`,
        getTasksInfo: `${services.tasks}/getTasksInfo`,
        getKanbanActivities: `${services.tasks}/kanban/getKanbanActivities`,
        ChangeDates: `${services.tasks}/v2/changeDates`,
        changeTaskResources: `${services.tasks}/changeTaskResources`,
        getAcHierarchy: `${services.tasks}/ActivityList/getHierarchy`,
        getProjectHierarchies: `${services.tasks}/ActivityList/getProjectHierarchies`,
        getAcChunk: `${services.tasks}/ActivityList/getChunk`,
        getIndicatorsData: `${services.tasks}/ActivityList/getIndicatorsData`,
        collapse: `${services.tasks}/ActivityList/collapse`,
        collapseAll: `${services.tasks}/ActivityList/collapseLevel`,
        acExpand: `${services.tasks}/ActivityList/expand`,
        expandAll: `${services.tasks}/ActivityList/expandLevel`,
        getHierarchyItemsCount: `${services.tasks}/ActivityList/getHierarchyItemsCount`,
        graphql: `${services.tasks}/graphql`,
        getCalendarActivities: `${services.tasks}/ActivityList/getCalendarActivities`,
        createTasks: `${services.tasks}/create-tasks`,
        batchOperations: {
            changeActivitiesSimpleProperties: `${services.tasks}/BatchOperations/ChangeActivitiesSimpleProperties`,
            deleteActivities: `${services.tasks}/BatchOperations/DeleteActivities`,
            changeActivitiesDates: `${services.tasks}/BatchOperations/ChangeActivitiesDates`,
            duplicateActivities: `${services.tasks}/BatchOperations/DuplicateActivities`,
            getActivitiesDeleteInfo: `${services.tasks}/BatchOperations/GetActivitiesDeleteInfo`,
            changeActivitiesAssignees: `${services.tasks}/BatchOperations/changeActivitiesAssignees`,
            getActivitiesAssignees: `${services.tasks}/BatchOperations/getActivitiesAssignees`,
            replaceActivitiesAssignees: `${services.tasks}/BatchOperations/replaceActivitiesAssignee`,
            update_following: `${services.tasks}/BatchOperations/update-following`,
            recaptureBaseline: `${services.tasks}/BatchOperations/recapture-baseline`,
        },
        search: `${services.tasks}/search`,
        indicators: {
            snooze: `${services.tasks}/indicators/snooze`,
            cancelSnooze: `${services.tasks}/indicators/cancel-snooze`,
        },
        expandAncestors: `${services.tasks}/expand-task-ancestors`,
        expand: `${services.tasks}/expand`,
        getAllAvailableFieldsForFormula: (fieldSpaceId) => {
            const query = fieldSpaceId ? `?fieldSpaceId=${fieldSpaceId}` : '';
            return `${services.tasks}/getAllAvailableFieldsForFormula${query}`;
        },
        checklist: (id) => `${services.tasks}/checklists/task/${id}/checklist`,
    },
    takedaCustomizations:{
        isProjectPlan: `${services.takedaCustomizations}/projectplans/is-project-plan`,
        makeLive: `${services.takedaCustomizations}/projectplans/make-live`,
    },
    project: {
        getAllProjectNamesWithCustomerId: `${services.projects}/getProjectNamesWithCustomers`,
        getVisibleProjectNames: `${services.projects}/getVisibleProjectNames`,
        getProjectNamesWithStatusFlags: `${services.projects}/getProjectNamesWithStatusFlags`,
        getBillingSettings: `${services.projects}/getBillingSettings`,
        getProjectNames: `${services.projects}/getProjectNames`,
        /**
         * @param projectId {number}
         * @returns {string}
         */
        getProjectPermissions: projectId => `${services.projects}/getProjectPermissions?id=${projectId}`,
        /**
         * @param projectId {number}
         * @param projectMemberId {number}
         * @returns {string}
         */
        getProjectMemberPermissions: (projectId, projectMemberId) => `${services.projects}/${projectId}/members/${projectMemberId}`,

        updateProjectField: `${services.projects}/updateProject`,
        updateProjectFields: `${services.projects}/updateProjectFields`,
        updateTotalTargetRevenue: `${services.projects}/updateTotalTargetRevenue`,
        updateTargetProfitAmount: `${services.projects}/updateTargetProfitAmount`,
        updateTargetProfitPercentages: `${services.projects}/updateTargetProfitPercentages`,
        updateJobRole: `${services.projects}/members/updateJobRole`,
        getProjectInfo: `${services.projects}/getProjectInfo`,
        getVisibleProjectsPortfolios: `${services.projects}/getVisibleProjectsPortfolios`,
        getPortfolioNames: `${services.projects}/getPortfolioNames`,
        search: `${services.projects}/search`,
        getMembersBatch: `${services.projects}/members/batch`,
        replaceMembersBatch: `${services.projects}/members/replaceBatch`,
        deleteProjectMember: `${services.projects}/members/deleteProjectMember`,
        saveUnnamedResource: `${services.projects}/unnamedResources/update`,
        getUnnamedResource: (id) => `${services.projects}/unnamedResources/${id}`,
        updateProjectsSpace: `${services.projects}/UpdateProjectsSpace`,
        unnamedResources:{
            all: `${services.projects}/unnamedresources`,
            getByProjectId: (id) => `${services.projects}/unnamedresources?projectIds=${id}`,
            get: `${services.projects}/unnamedresources`,
        },
        create: `${services.projects}/create`,
        checklist: (id) => `${services.tasks}/checklists/project/${id}/checklist`,
        getProjectTimelogsPermission: `${services.tasks}/projecttimelogs/get-permissions`,
        getTimesheetsTask: `${services.tasks}/projecttimelogs/get-timesheets-task`,
    },
    onboarding: {
        addProjectAndActivities:`${ep.appRoot}onboarding/sampleData/addProjectAndActivities`,
        addActivities: `${ep.appRoot}onboarding/sampleData/addActivities`,
        sampleData: {
          create: `${ep.appRoot}onboarding/sampleData/create`,
          delete: `${ep.appRoot}onboarding/sampleData/delete`,
        }
    },
    user: {
        saveUserOnboarding: ep.appRoot + "UserOnboarding/Save",
        getCurrentUserInfo: `${ep.appRoot}personaloptions/api/getProfileInfo`,
    },
    upgradePlanTemplate: ep.appRoot + "UpgradePlan/Index?featureName={0}",
    upgradePlan: ep.appRoot + "UpgradePlan/Upgrade",
    purchase: {
        purchaseUsers: ep.appRoot + "Purchase/PurchaseUsers",
        purchaseBirdviewAutomation: ep.appRoot + "Purchase/PurchaseBirdviewAutomation",
    },
    request: {
        requestPowerBI: ep.appRoot + "Purchase/RequestPowerBI",
        requestTrialBirdviewAutomation: ep.appRoot + "Purchase/RequestTrialBirdviewAutomation",
    },
    pushNotifications: {
        createOrUpdateInstallation: ep.appRoot + "PushNotifications/CreateOrUpdateInstallation"
    },
    newProject: {
        getSourceTemplateProjects: ep.appRoot + "ActivityCenter/GetQuickAddSourceTemplateProjects"
    },
    statuses: {
        /**
         * @param entityId {number}
         * @returns {string}
         */
        getStatusesForEntity: entityId => `${services.systemLists}/statuses/forEntity/${entityId}`,
        getStatusesForProject: `${services.systemLists}/statuses/forProject`,
        getStatusesForPortfolio: `${services.systemLists}/statuses/forEntity/${AppEntityID.Portfolio}`,
        graphql: `${services.systemLists}/graphql`,
    },
    myAssignments: {
        getTasks: `${services.tasks}/getForMyAssignments`,
        updateSettings: ep.appRoot + "myassignments/UpdateSettings",
        mainPageUrl: ep.appRoot + 'myassignments',
        startTimer: ep.appRoot + "myassignments/StartTimer",
        getTimer: ep.appRoot + "myassignments/CurrentTimer",
        pauseTimer: ep.appRoot + "myassignments/PauseTimer",
        deleteTimer: ep.appRoot + "myassignments/DeleteTimer",
        getProjectsList: ep.appRoot + 'myassignments/Projects',
        getParentsTasksList: ep.appRoot + 'myassignments/Activities',
        createTask: ep.appRoot + 'myassignments/CreateTask',
        canCreateTask: `${ep.appRoot}services/projects/getCanCreateTaskInOpenedProjects`
    },
    guestPortal: {
        mainPageUrl: ep.appRoot + 'guestportal',
    },
    users: {
        quickAdd: ep.appRoot + "UserDetails.aspx?eplnk=1&CloseTrigger=NewUserTrigger&modal=1&quick=1",
        mainPageUrl: ep.appRoot + "users",
        getUsersInitModel: ep.appRoot + "users/GetUsersInitModel",
        getDetails: ep.appRoot + "users/GetDetails",
        saveCustomization: ep.appRoot + "Users/SaveCustomization",
        saveFilter: ep.appRoot + "users/SaveFilter",
        getUserSecurityLog: ep.appRoot + "Users/GetSecurityLog",
        getUserStatus: ep.appRoot + "editUser/GetUserStatus",
        changeUserStatus: ep.appRoot + "editUser/ChangeUserStatus",
        importUsers: ep.appRoot + "CsvUserImport.aspx",
        getUsers: ep.appRoot + "users/GetUsers",
        changeName: ep.appRoot + "editUser/ChangeName",
        changeLogin: ep.appRoot + "editUser/ChangeLogin",
        changeEmail: ep.appRoot + "editUser/ChangeEmail",
        changeRole: ep.appRoot + "editUser/ChangeRole",
        changeCustomer: ep.appRoot + "editUser/ChangeCustomer",
        changeSchedule: ep.appRoot + "editUser/ChangeSchedule",
        changeHourlyRate: ep.appRoot + "editUser/ChangeHourlyRate",
        changeHourlyRateInternal: ep.appRoot + "editUser/ChangeHourlyRateInternal",
        changePassword: ep.appRoot + "editUser/ChangePassword",
        getUserModel: ep.appRoot + "users/GetUserModel",
        getRoles: ep.appRoot + "editUser/GetRoles",
        getUserInviteModel: ep.appRoot + "users/GetUserInviteModel",
        getRateHistory: ep.appRoot + "editUser/GetRateHistory",
        deleteHourlyRate: ep.appRoot + "editUser/DeleteHourlyRate",
        getCustomers: ep.appRoot + "editUser/GetCustomers",
        getRolesForConversion: ep.appRoot + "editUser/GetRolesForGuestConversion",
        saveCustomField: ep.appRoot + "editUser/ChangeCustomField",
        resetPassword: ep.appRoot + "editUser/GeneratePassword",
        resetPermissions: `${ep.appRoot}editUser/ResetPermissions`,
        convertToRegularUser: ep.appRoot + "editUser/Convert",
        changeTeams: ep.appRoot + "editUser/ChangeTeams",
        changeSkills: ep.appRoot + "editUser/ChangeSkills",
        deleteTeam:`${ep.appRoot}editUser/DeleteTeam`,
        unlock:`${ep.appRoot}editUser/Unlock`,
        getAbilityToDelete: `${ep.appRoot}editUser/GetDeleteInfo`,
        deleteUser: `${ep.appRoot}editUser/DeleteUser`,
        createUser: `${ep.appRoot}references/CreateUser`,
        assignTeams: `${ep.appRoot}users/AssignTeams`,
        excludeTeams: `${ep.appRoot}users/ExcludeTeams`,
        getAllTeams: `${ep.appRoot}users/GetAllTeams`,
        getAllSkills: `${ep.appRoot}users/GetAllSkills`,
        assignSkills: `${ep.appRoot}users/AssignSkills`,
        excludeSkills: `${ep.appRoot}users/ExcludeSkills`,
    },
    reference: {
        getActivityCategories: ep.appRoot + "References/GetActivityCategories",
        getAvailableActivityStatuses: ep.appRoot + "References/GetAvailableActivityStatuses",
        getAvailablePriorities: ep.appRoot + "References/GetAvailablePriorities",
        getAvailableProjectStatuses: ep.appRoot + "References/GetAvailableProjectStatuses",
        getEditProjectMembersModel: ep.appRoot + "References/GetEditProjectMembersModel",
        getLastAddedMember: ep.appRoot + "References/GetLastAddedMember",
        getUserInfoModel: ep.appRoot + "References/GetUserInfoModel",
        getUtilityData: ep.appRoot + "References/GetUtilityData",
        getUserSchedule: ep.appRoot + "References/GetUserSchedule",
        getVisibleUsers: ep.appRoot + "References/GetVisibleUsers",
        getUsersInfo: ep.appRoot + "References/getUsersInfo",
        getVisibleTeams: ep.appRoot + "References/GetTeamsWithVisibleUsers",
        getRoles: ep.appRoot + "References/GetRoles",
        canCompleteParent: ep.appRoot + "References/CanCompleteParent",
        getUserVacations: ep.appRoot + "References/GetUserVacations",
        getProjectNames: `${ep.appRoot}References/getProjectNames`,
        getTaskNames: `${ep.appRoot}References/getTaskNames`,
        getPortfolioNames: `${ep.appRoot}References/getPortfolioNames`,
    },
    inlineEdit: {
        changeDatesRollup: ep.appRoot + "InlineEdit/ChangeDatesRollup",
        changeActivityName: ep.appRoot + "InlineEdit/ChangeActivityName",
        changeProjectName: ep.appRoot + "InlineEdit/ChangeProjectName",
        changeActivityStatus: ep.appRoot + "InlineEdit/ChangeActivityStatus",
        changeActivityIamDoneState: ep.appRoot + "InlineEdit/ChangeActivityIamDoneState",
        changeProjectStatus: ep.appRoot + "InlineEdit/ChangeProjectStatus",
        changeActivityCategory: ep.appRoot + "InlineEdit/ChangeActivityCategory",
        changeActivityPriority: ep.appRoot + "InlineEdit/ChangeActivityPriority",
        changeProjectPriority: ep.appRoot + "InlineEdit/ChangeProjectPriority",
        changeActivityProgress: ep.appRoot + "InlineEdit/ChangeActivityProgress",
        changeProjectProgress: ep.appRoot + "InlineEdit/ChangeProjectProgress",
        changeActivityDates: ep.appRoot + "InlineEdit/ChangeActivityDates",
        changeActivityActualCompletionDate: ep.appRoot + "InlineEdit/ChangeActivityActualCompletionDate",
        changeProjectDates: ep.appRoot + "InlineEdit/ChangeProjectDates",
        updateEntityDates: ep.appRoot + "InlineEdit/UpdateEntityDates",
        changeProjectActualCompletionDate: ep.appRoot + "InlineEdit/ChangeProjectActualCompletionDate",
        changeDependencies: ep.appRoot + "InlineEdit/ChangeDependencies",
        changeTaskResources: ep.appRoot + "InlineEdit/ChangeTaskResources",
        changeAssignees: ep.appRoot + "InlineEdit/ChangeAssignees",
        changeProjectMembers: ep.appRoot + "InlineEdit/ChangeProjectMembers",
        changeActivityEstimatedHours: ep.appRoot + "InlineEdit/ChangeActivityEstimatedHours",
        changeProjectEstimatedHours: ep.appRoot + "InlineEdit/ChangeProjectEstimatedHours",
        changeProjectBudget: ep.appRoot + "InlineEdit/ChangeProjectBudget",
        changeActivityBudget: ep.appRoot + "InlineEdit/ChangeActivityBudget",
        changeProjectDescription: ep.appRoot + "InlineEdit/ChangeProjectDescription",
        changeActivityDescription: ep.appRoot + "InlineEdit/ChangeActivityDescription",
        updateMessagesCount: ep.appRoot + "InlineEdit/UpdateMessagesCount",
        changeProjectPortfolio: ep.appRoot + "InlineEdit/ChangeProjectPortfolio",
        changeProjectCustomer: ep.appRoot + "InlineEdit/ChangeProjectCustomer",
        changeCustomFields: ep.appRoot + "InlineEdit/ChangeCustomFields",

        calculateActivityDates: ep.appRoot + "InlineEdit/CalculateActivityDates",
        calculateProjectDates: ep.appRoot + "InlineEdit/CalculateProjectDates",
        getCanEditActivityDates: ep.appRoot + "InlineEdit/GetCanEditActivityDates",
        getCanEditProjectDates: ep.appRoot + "InlineEdit/GetCanEditProjectDates",
        getActivityProgressEditModel: ep.appRoot + "InlineEdit/GetActivityProgressEditModel",
        getProjectProgressEditModel: ep.appRoot + "InlineEdit/GetProjectProgressEditModel",
        getCustomersEditModel: ep.appRoot + "InlineEdit/GetCustomersEditModel",
        reorderOnFlatViewWithoutProjects: ep.appRoot + "InlineEdit/ReorderOnFlatViewWithoutProjects",
        changeWBSNumber: ep.appRoot + "InlineEdit/ChangeWBSNumber",
        changeParent: ep.appRoot + "InlineEdit/ChangeParent",
        addDependency: ep.appRoot + "InlineEdit/AddDependency",
        changeDate: ep.appRoot + "InlineEdit/ChangeDate",
        addTimelog: ep.appRoot + "InlineEdit/AddTimelog",
        recordTimelogs: ep.appRoot + "InlineEdit/RecordTimelogs",
        updateActivityWBSAndStatus: ep.appRoot + "InlineEdit/UpdateActivityWBSAndStatus",
        undoAction: ep.appRoot + "InlineEdit/Undo",

        update_following_in_project: ep.appRoot + "InlineEdit/ChangeFollowing",
    },
    activityDependency: {
        getDependencies: ep.appRoot + "ActivityDependency/GetActivityDependencies",
        getDependencyMasterTasksForActivity: ep.appRoot + "ActivityDependency/GetMasterTasksForActivity",
        getPossibleDependentTasks: ep.appRoot + "ActivityDependency/GetPossibleDependentTasks",
    },
    roles: {
        /*
        * @obsolete use roles.roles instead
        */
        getRolesList: `${services.roles}/api/getRolesList`,
        list: `${services.usermanagement.roles}/all`,
        save: `${services.roles}/api/save`,
        create: `${services.roles}/api/create`,
        deleteInfo: `${services.roles}/api/getDeleteInfo`,
        delete: `${services.roles}/api/delete`,
        getAll: `${services.roles}/api/roles`,
        getRestricted: `${services.roles}/api/restricted`,
        v2: {
            roles: ({includeAdmin, includeGuest}) => `${services.roles}/api/v2/roles?includeAdmin=${includeAdmin}&includeGuest=${includeGuest}`,
        }
    },
    customers: {
        list: `${services.customers}/all`,
        getCustomerNames: `${services.customers}/getcustomernames`,
        permissions: `${services.customers}/permissions`,
        getFilter: `${services.customers}/getfilter`,
        saveFilter: `${services.customers}/savefilter`,
        getCustomizations: `${services.customers}/getcustomization`,
        saveCustomization: `${services.customers}/savecustomization`,
        saveFieldValue: `${services.customers}/savefieldvalue`,
        create: `${services.customers}/create`,
        countries: `${services.customers}/countries/list`,
        delete: `${services.customers}/delete`,
        deleteInfo: `${services.customers}/getDeleteInfo`,
        importCustomers: ep.appRoot + "CsvCustomerImport.aspx",
        exportToCSV: `${services.customers}/export/csv`,
        getShippingInfo: `${services.customers}/getShippingInfo`,
    },
    customFields: {
        deleteField: `${ep.appRoot}customfieldsprovider/api/external/delete`,
        canDeleteField: `${ep.appRoot}customfieldsprovider/api/external/canDelete`,
        reorderFields: `${ep.appRoot}customfieldsprovider/api/external/reorderFields`,
        getFieldDetails: `${ep.appRoot}customfieldsprovider/api/external/getFieldDetails`,
        createField: `${ep.appRoot}customfieldsprovider/api/external/createField`,
        updateField: `${ep.appRoot}customfieldsprovider/api/external/updateField`,
        getAll: `${ep.appRoot}customfieldsprovider/api/external/getAll`,
        getByEntityId: `${ep.appRoot}customfieldsprovider/api/external/getByEntityId`,
        canCreateField: `${ep.appRoot}customfieldsprovider/api/external/canCreateField`,
        linkFieldToSpace: `${ep.appRoot}customfieldsprovider/api/external/linkFieldToSpace`,
        batchUpdateIsRequired: `${ep.appRoot}customfieldsprovider/api/external/batchUpdateIsRequired`,
    },
    kanban: {
        getActivities: `${ep.appRoot}Kanban/GetActivities`,
        getStatuses: `${ep.appRoot}Kanban/GetActivityStatuses`,
        getProjectNames: `${ep.appRoot}services/projects/getprojectnames`,
        createTask: `${ep.appRoot}Kanban/CreateTask`
    },
    calendar: {
        getActivities: `${ep.appRoot}Calendar/GetActivities`,
    },
    projectFinancials: {
        changeProjectCurrency: ep.appRoot + "ProjectFinancials/ChangeProjectCurrency",
        changeProjectBudget: ep.appRoot + "ProjectFinancials/ChangeProjectBudget",
        getMetrics: ep.appRoot + "ProjectFinancials/GetMetrics",
        printReport: `${ep.appRoot}ProjectFinancialsReport.aspx?ProjectID={0}`,
        updatePaymentFields: ep.appRoot + "ProjectFinancials/UpdatePaymentFields",
        addPayment: ep.appRoot + "ProjectFinancials/AddPayment",
        deletePayment: ep.appRoot + 'ProjectFinancials/DeletePayment'
    },
    myOptions: {
        logout: `${ep.appRoot}MyOptions/SignOutAllDevices`,
        getProfileInfo: `${ep.appRoot}MyOptions/GetProfileInfo`,
        saveNameAndEmail: `${ep.appRoot}MyOptions/SaveNameAndEmail`,
        changePassword: `${ep.appRoot}MyOptions/ChangePassword`,
        saveAvatar: `${ep.appRoot}MyOptions/SaveAvatar`,
        deleteAvatar: `${ep.appRoot}MyOptions/DeleteAvatar`,
        getSettings: `${ep.appRoot}personaloptions/api/getSettingsInfo`,
        changeLanguage: `${ep.appRoot}personaloptions/api/changeLanguage`,
        saveDefaultPage: `${ep.appRoot}personaloptions/api/saveDefaultPage`,
        saveShowCompletedProjects: `${ep.appRoot}personaloptions/api/saveShowCompletedProjects`,
        saveShowCompletedTasks: `${ep.appRoot}personaloptions/api/saveShowCompletedTasks`,
        getNotificationsData: `${ep.appRoot}personaloptions/api/getNotificationsInfo`,
        updateNotificationOptions: `${ep.appRoot}personaloptions/api/updateNotificationOptions`,
        updateNotificationsEvents: `${ep.appRoot}personaloptions/api/updateNotificationsEvents`,
        updateAutoFollowEvents : `${ep.appRoot}personaloptions/api/updateAutoFollowEvents `,
        getCommonOptions: `${ep.appRoot}personaloptions/api/getCommonOptions`,
    },
    options: {
        getScheduleSettings: `${services.options}/api/companySchedule`,
        getCompanyScheduleSettings: `${services.options}/api/getScheduleSettings`,
        updateOption: `${services.options}/api/updateOption`,
        updateOptions: `${services.options}/api/updateOptions`,
        setWeekendsAsWorkdays: `${ep.appRoot}options/setWeekendsAsWorkdays`,
        getAdvancedSettings: `${services.options}/api/advanced`,
        getSSOSettings: `${services.options}/api/sso`,
        currencies: `${services.options}/api/currencies`,
        getPayrollOptions: `${ep.appRoot}options/getPayrollOptions`,
        taskCreators: `${services.options}/api/possibleTaskCreators`,
        getSecuritySettings: `${services.options}/api/security`,
        updateOvertimeThreshold: `${services.options}/api/overtimeThreshold/update`,
        testConnection: `${services.options}/api/testConnection`,
        deleteOvertimeThreshold: `${services.options}/api/overtimeThreshold/delete`,
        addOvertimeThreshold: `${services.options}/api/overtimeThreshold/add`,
        companyLogo: `${services.options}/api/logo`,
        saveCompanyLogo: `${services.options}/api/logo`,
        deleteCompanyLogo: `${services.options}/api/logo/delete`,
        getLogoInfo: `${services.options}/api/logo/getLogoInfo`,
        updateSSOSignInBtnText: `${services.options}/api/updateSSOSignInBtnText`,
        prohibitedWords: {
            download: `${services.options}/api/getProhibitedPasswordWords`,
            upload: `${services.options}/api/uploadProhibitedPasswordWords`,
            enable: `${services.options}/api/enforceProhibitedWordsPolicy`,
        },
        getCertificate: `${services.options}/api/sso/saml/certificate`,
        clientOptions: `${services.options}/api/clientOptions`,
        sAMLMetadata: {
            update: {
                fromFile: `${services.options}/api/uploadSAMLMetadata`,
                fromXmlString: `${services.options}/api/updateSAMLMetadata`,
                fromUrl: `${services.options}/api/updateSAMLMetadataUrl`,
            },
            get: `${services.options}/api/getSAMLMetadata`,
        }
    },
    systemLists: {
        getCategories: `${services.systemLists}/getCategories`,
        getCategoryNames: `${services.systemLists}/getCategoryNames`,
        addCategory: `${services.systemLists}/addCategory`,
        deleteCategory: `${services.systemLists}/deleteCategory`,
        renameCategory: `${services.systemLists}/renameCategory`,
        deletePriority: `${services.systemLists}/deletePriority`,
        getPriorities: `${services.systemLists}/getPriorities`,
        getPriorityNames: `${services.systemLists}/getPriorityNames`,
        renamePriority: `${services.systemLists}/renamePriority`,
        reorderPriority: `${services.systemLists}/reorderPriority`,
        addPriority: `${services.systemLists}/addPriority`,
        getVacationTypes: `${services.systemLists}/getVacationTypes`,
        getVacationTypesColors: `${services.systemLists}/getVacationTypesColors`,
        renameVacationType: `${services.systemLists}/renameVacationType`,
        updateVacationTypeField: `${services.systemLists}/updateVacationTypeField`,
        deleteVacationType: `${services.systemLists}/deleteVacationType`,
        addVacationType: `${services.systemLists}/addVacationType`,
        getThresholds: `${services.systemLists}/getThresholds`,
        renameThreshold: `${services.systemLists}/renameThreshold`,
        updateThresholdField: `${services.systemLists}/updateThresholdField`,
        deleteThreshold: `${services.systemLists}/deleteThreshold`,
        addThreshold: `${services.systemLists}/addThreshold`,
        getDefaultPriorityId: `${services.systemLists}/getDefaultPriorityId`,
        getPublicHoliday: `${services.systemLists}/publicHoliday/getAll`,
        renamePublicHoliday: `${ep.appRoot}publicholidays/rename`,
        updateDatePublicHoliday: `${ep.appRoot}publicholidays/updateDate`,
        deletePublicHoliday: `${ep.appRoot}publicholidays/delete`,
        addPublicHoliday: `${ep.appRoot}publicholidays/add`,
        getWorkflows: `${services.systemLists}/getWorkflows`,
        getWorkflowDetails: (id) => `${services.systemLists}/getWorkflowStatuses/${id}`,
        linkWorkflowToSpace: `${services.systemLists}/linkWorkflowToSpace`,
        getStatusesForSuggestion: `${services.systemLists}/statuses/getStatusesForSuggestion`,
        renameWorkflow: `${services.systemLists}/renameWorkflow`,
        getWorkflowsLite: `${services.systemLists}/getWorkflowsLite`,
        changeWorkflowForProject: `${services.systemLists}/changeWorkflowForProject`,
        applyWorkflowForProject: `${services.systemLists}/applyWorkflowForProject`,
        addWorkflow: `${services.systemLists}/addWorkflow`,
        updateStatusField: `${services.systemLists}/statuses/updateStatusField`,
        getPortfolioWorkflowStatuses: `${services.systemLists}/statuses/forWorkflow/portfolio`,
        addStatus: `${services.systemLists}/statuses/addStatus`,
        renameStatus: `${services.systemLists}/statuses/renameStatus`,
        reorderStatus: `${services.systemLists}/statuses/reorderStatus`,
        deleteStatus: `${services.systemLists}/statuses/deleteStatus`,
        switchStatusForEntity: `${services.systemLists}/statuses/switchStatusForEntity`,
        setStatusWorkflowType: `${services.systemLists}/statuses/setStatusWorkflowType`,
        duplicateWorkflow: `${services.systemLists}/duplicateWorkflow`,
        markWorkflowAsDefault: `${services.systemLists}/markWorkflowAsDefault`,
        markWorkflowAsDefaultForSpace : `${services.systemLists}/markWorkflowAsDefaultForSpace`,
        deleteWorkflow: `${services.systemLists}/deleteWorkflow`,
        oauthClients: {
            getAll: `${services.systemLists}/oauthclients/get-all`,
            create: `${services.systemLists}/oauthclients/create`,
            delete: `${services.systemLists}/oauthclients/delete`,
            update: `${services.systemLists}/oauthclients/update`,
            regenerateSecret: `${services.systemLists}/oauthclients/regenerate-secret`,
        }
    },
    search: {
        mainPageUrl: `${ep.appRoot}Search`,
        getSearchResult: `${ep.appRoot}Search/GetResult`,
        getSearchResultV2: `${ep.appRoot}search/v2/api/results`,
        getSearchSettings: `${ep.appRoot}search/v2/api/searchSettings/get`,
    },
    signalr: {
        hubUrl: `${ep.appRoot}services/signalr/EpEvents`
    },
    timelogs: {
        timelogHistoryDetailsFormat: url => `${ensureLastSlash(ep.uiAppRoot || ep.appRoot) + url}FilterProjectID={0}&FilterTasksID={1}&FilterDateRange={2}&FilterDateFrom={3}&FilterDateTo={4}`,
        getTimeLogs: `${ep.appRoot}timelogs/GetTimelogs`,
        getTimeLogsForMonth: `${ep.appRoot}timelogs/GetTimelogsDuration`,
        getSettings: `${ep.appRoot}timelogs/GetSettings`,
        getTimeLogDetails: `${ep.appRoot}timelogs/GetDetails`,
        updateTimelog: `${ep.appRoot}timelogs/UpdateTimelog`,
        addTimelog: `${ep.appRoot}timelogs/AddTimelog`,
        deleteTimelog: `${ep.appRoot}timelogs/DeleteTimelog`,
        deleteTimelogsRow: `${ep.appRoot}timelogs/DeleteTimelogs`,
        getAssignedTasksInfo: `${ep.appRoot}timelogs/GetAssignedTasksInfo`,
        getProjectsForTLCreation: `${ep.appRoot}timelogs/GetProjectsForTimeLogCreation`,
        getActualHours: `${services.timelogs}/getUsersActualTimeForTask`,
        getCustomization: `${services.timelogs}/getcustomization`,
        saveCustomization: `${services.timelogs}/savecustomization`,
        loadTimelogsEntries: `${services.timelogs}/all`,
        getBatchOfTimeLogEntries: `${services.timelogs}/getbatch`,
        saveTimelogEntry: `${services.timelogs}/savefieldvalue`,
        loadTimeLogsTotals: `${services.timelogs}/gettotalhours`,
        batchUpdate: `${services.timelogs}/batchupdate`,
        batchUpdateCustomFields: `${services.timelogs}/batchupdate/customfields`,
        unlock: `${services.timelogs}/unlock`,
        getForTimeLogs: `${services.tasks}/getForTimeLogs`,
        getProjects: `${services.timelogs}/getprojects`,
        exportToCsv: `${services.timelogs}/export/csv`,
        copyTimelogs: `${ep.appRoot}timelogs/CopyTimelogs`,
        graphql: `${services.timelogs}/graphql`,
    },
    reactions: {
        /**
         * @param projectId {number}
         * @param [messageId] {number}
         * @returns {string}
         */
        getForProject: (projectId, messageId) => `${services.messages}/load-reactions?projectId=${projectId}${messageId ? `&messageId=${messageId}` : ''}`,
        /**
         * @param taskId {number}
         * @param [messageId] {number}
         * @returns {string}
         */
        getForTask: (taskId, messageId ) => `${services.messages}/load-reactions?taskId=${taskId}${messageId ? `&messageId=${messageId}` : ''}`,
        post: `${services.messages}/post-reaction`,
        delete: `${services.messages}/delete-reaction`
    },
    annotations: {
        /**
         * @param projectId {number}
         * @returns {string}
         */
        getForProject: (projectId) => `${ep.appRoot}annotations/api/project/${projectId}`,
        /**
         * @param taskId {number}
         * @returns {string}
         */
        getForTask: (taskId) => `${ep.appRoot}annotations/api/activity/${taskId}`,
        create: `${ep.appRoot}annotations/api/create`
    },
    ml: {
        /**
         * @param projectId {number}
         * @returns {string}
         */
        getPredictionUrlForProject: (projectId) => `${ep.appRoot}ml/api/predict/${projectId}`,
    },
    forms: {
        getForms: {
            publish: `${services.forms}/forms/publish`,
            draft: `${services.forms}/forms/draft`,
            archive: `${services.forms}/forms/archive`,
        },
        graphql: `${services.forms}/graphql`,
        getFormRecords: `${services.forms}/records/list`,
        getFormsCounts: `${services.forms}/forms/countsByStatuses`,
        createForm: `${ep.appRoot}forms/create`,
        newRecord: `${ep.appRoot}FormRecords/New`,
        createRecord: `${ep.appRoot}FormRecords/Create`,
        getFormRecordForEdit: `${ep.appRoot}FormRecords/Edit`,
        updateRecord: `${ep.appRoot}FormRecords/Update`,
        markRecordAsRead: `${ep.appRoot}FormRecords/MarkRecordAsRead`,
        exportRecords: `${ep.appRoot}FormRecords/ExportRecords`,
        getLoadFormRecordUrl: (recordId) => `${services.forms}/records/${recordId}`,
        deleteRecord: `${services.forms}/records/delete`,
        getRecordInfo: `${ep.appRoot}FormRecords/GetRecord`,
        getRecordForConversion: `${ep.appRoot}FormRecords/GetRecordForConversion`,
        getConversionMappingOptions: `${ep.appRoot}FormRecords/GetMappingOptions`,
        convertRecord: `${ep.appRoot}FormRecords/Convert`,
        newForm: `${ep.appRoot}forms/new`,
        updateForm: `${ep.appRoot}forms/update`,
        deleteForm: `${ep.appRoot}forms/formDelete`,
        getForm: formId => `${ep.appRoot}form/${formId}/edit`,
        goBackUrl: `${ep.appRoot}forms/goBack`,
        updateOnBoardingState: `${ep.appRoot}forms/updateOnBoardingState`,
        getMappingOptionsUrl: `${ep.appRoot}forms/getMappingOptions`,
        preview: `${ep.appRoot}formRecords/preview`
    },
    menu: {
        getUserSettings: `${services.usermanagement.permissions}/userSettings`,
    },
    whatif: {
        getResources: `${ep.appRoot}Whatif/GetResources`,
        getScheduleSettings: `${ep.appRoot}Whatif/GetScheduleSettings`,
        getRestrictions: `${ep.appRoot}Whatif/GetRestrictions`,
        search:`${ep.appRoot}Whatif/search`,
        startProject: `${ep.appRoot}Whatif/StartProject`,
    },
    personalization: {
        load: `${ep.appRoot}personalizationmanager/api/v2/load`,
        save: `${ep.appRoot}personalizationmanager/api/save`,
        loadMultipleValues: `${ep.appRoot}personalizationmanager/api/loadMultipleValues`,
        delete: `${ep.appRoot}personalizationmanager/api/delete`,
    },
    reports: {
        getForDashboard: `${services.reports}/widgets/get`,
        markAsBilled: `${ep.appRoot}BillingReport/MarkAsBilled`,
        getReportMetadata: `${services.reports}/getreportmetadata`,
        customFieldsLists: `${services.reports}/customFieldsLists`,
        getCustomReports: `${services.reports}/get`,
        removeCustomReport: `${ep.appRoot}Reports/Delete`,
        getReportDetailsModel: `${ep.appRoot}reports/getReportDetailsModel`,
        saveReport: `${ep.appRoot}reports/saveReport`,
        copyReport: `${ep.appRoot}reports/copyReport`,
        getPowerBIConfiguration: `${services.reports}/powerbi/configuration`,
        getPowerBIReportModel: `${services.reports}/powerbi/reportModel`,
        incrementWidgetsCountForReport: `${services.reports}/widgets/incrementWidgetsCountForReport`,
        decrementWidgetsCountForReport: `${services.reports}/widgets/decrementWidgetsCountForReport`,
        toggleOnDashboard: `${services.reports}/toggleOnDashboard`,
        getChartReportData: `${services.reports}/getChartReportData`,
        exportToCSV: `${services.reports}/exportToCSV`,
        exportToExcel: `${services.reports}/exportToExcel`,
        getMetricReportData: `${services.reports}/getMetricReportData`,
        getTableReportData: `${services.reports}/getReportData`,
        getReportInfo: `${services.reports}/getReportInfo`,

        startBIReportExport: `${services.reports}/powerbi/exportReport`,
        getBIExportStatus: `${services.reports}/powerbi/exportStatus`,
        downLoadBIExportedFile: `${services.reports}/powerbi/downloadReport`,
    },
    resources: {
        getReport: `${services.resources}/GetReportData`,
        getJobRoles: `${services.resources}/jobroles`,
        deleteJobRole: (id) => `${services.resources}/jobroles/${id}`,
        updateFieldValue: (id) => `${services.resources}/jobroles/${id}/update`,
        getDeleteJobRoleInfo: (id) => `${services.resources}/jobroles/${id}/deleteInfo`,
        exportReport: `${services.resources}/ExportReport`,
        SaveManualSchedule: `${services.resources}/SaveManualSchedule`,
        DeleteManualSchedule: `${services.resources}/DeleteManualSchedule`,
        ResetManualSchedule: `${services.resources}/ResetManualSchedule`,
        GetAvailableHours: `${services.resources}/GetAvailableHours`,
        UpdateScheduledHours: `${services.resources}/UpdateScheduledHours`,
        softAllocationHours: `${services.resources}/softAllocationHours`,
        planningGantt: `${services.resources}/reports/planning`,
        getScheduledMinutesByProjectIds: `${services.resources}/GetDetailedReportDataByProjectIds`,
        getScheduledMinutesByResourceIds: `${services.resources}/GetDetailedReportDataByResourceIds`,
        recommendations: `${services.resources}/reports/recommendations`,
        graphql: `${services.resources}/graphql`,
        getHierarchy: `${services.resources}/resourcePlanning/GetHierarchy`,
        expand: `${services.resources}/resourcePlanning/expand`,
        collapse: `${services.resources}/resourcePlanning/collapse`,
        getChunk:  `${services.resources}/resourcePlanning/getChunk`,
        getAnyAllocationsExists: `${services.resources}/allocations/any`,
        batchAllocationsApprove: `${services.resources}/resourcePlanning/batch-allocations-approve`,
        batchAllocationsReject: `${services.resources}/resourcePlanning/batch-allocations-reject`,
        batchAllocationsGenerate: `${services.resources}/resourcePlanning/batch-allocations-generate`,
        batchAllocationsRegenerate: `${services.resources}/resourcePlanning/batch-allocations-regenerate`,
        getPossibleAllocationsApprovers: `${services.resources}/resourcePlanning/batch-allocations-approvers`,
        normalizeApprovers: `${services.resources}/allocations/normalize-approvers`,
        copyMultipleTimes: `${services.projects}/unnamedresources/copy-multiple-times`
    },
    payroll: {
        getPayroll: `${ep.appRoot}Payroll/GetPayroll`,
        exportToExcel: `${ep.appRoot}Payroll/ExportToExcel`,
        templateUrl: `${ep.appRoot}Payroll/GetTemplate`,
    },
    usermanagement: {
        users: {
            all: `${services.usermanagement.users}/all`,
            getNames: `${services.usermanagement.users}/getNames`,
            getAccountSettings: `${services.usermanagement.permissions}/accountSettings`,
            getUserSettings: `${services.usermanagement.users}/getUserSettings`,
            updateUserField: `${services.usermanagement.users}/updateUserField`,
            schedules: `${services.usermanagement.users}/schedules/load`,
            setJobRole: `${services.usermanagement.users}/batchUpdateJobRole`,
            exportToCSV: `${services.usermanagement.users}/export/csv`,
        },
        teams: {
            all: `${services.usermanagement.teams}/all`,
            getTeamNames: `${services.usermanagement.teams}/getTeamNames`,
            createTeam: `${services.usermanagement.teams}`,
        },
        skills: {
            all: `${services.usermanagement.skills}`,
            getSkillNames: `${services.usermanagement.skills}/getSkillNames`,
            createSkill: `${services.usermanagement.skills}`,
            delete: `${services.usermanagement.skills}/delete`,
        },
        permissions: services.usermanagement.permissions,
        getUpgradePlanLink: `${services.usermanagement.permissions}/get-upgrade-plan-link`
    },
    license: {
        get: `${services.licenses}/license`,
        add: `${ep.appRoot}AddLicenses`,
        update: `${ep.appRoot}license/update`,
        updatePlan: `${ep.appRoot}license/updatePlan`,
    },
    customization: {
        getForClient: `${services.customization}/getForClient`,
        features: `${services.customization}/features`
    },
    external: {
        saveTeamFunction: `${services.external}/api/accountscontrol/save-team-functions`,
    },
    portfolio: {
        getPortfolioNames: `${services.portfolios}/api/getPortfolioNames`,
        getList: `${services.portfolios}/api/all`,
        getVisible: `${services.portfolios}/api/allvisible`,
        create: `${services.portfolios}/api/create`,
        getCustomization: `${services.portfolios}/api/getcustomization`,
        saveCustomization: `${services.portfolios}/api/savecustomization`,
        getDetails: `${services.portfolios}/api/getdetails`,
        delete: `${services.portfolios}/api/delete`,
        saveFieldValue: `${services.portfolios}/api/savefieldvalue`,
        loadMissedUsers: `${services.portfolios}/api/getportfoliomembers`,
        getCanCreatePortfolio: `${services.portfolios}/api/canCreatePortfolio`,
    },
    readMore: {
        project_health: "https://help.birdviewpsa.com/hc/en-us/articles/115001751711-Company-settings-advanced-settings#Project_health_(Earned_Value_Analysis)_settings",
        password_policy: "https://help.birdviewpsa.com/hc/en-us/articles/115001762192-Password-Policy",
        security_policy: "https://help.birdviewpsa.com/hc/en-us/articles/115001762192-Company-settings-security-policy",
        sso_enabled: "https://help.birdviewpsa.com/hc/en-us/articles/115001750871-Single-sign-on-options",
        common_notif_rule: "https://help.birdviewpsa.com/hc/en-us/articles/115001761692-Common-notification-rule",
        email_notif_settings: "https://help.birdviewpsa.com/hc/en-us/articles/115002827292-Email-notifications-settings",
        archiving_project: "https://help.birdviewpsa.com/hc/en-us/articles/6362508956941",
        hours_allocation_help: "https://help.birdviewpsa.com/hc/en-us/articles/8915996692749-Scheduling-Activity-Hours",
        dates_rollup: "https://help.birdviewpsa.com/hc/en-us/articles/7385235334157-Date-Rollup",
        time_tracking_policy: "https://help.birdviewpsa.com/hc/en-us/articles/24302036498445-Time-locking",
        planning_managing_allocations: "https://help.birdviewpsa.com/hc/en-us/articles/13845648430349-Planning-Managing-allocations",
    },
    notifications: {
        options: {
            get: `${services.notifications}/options`,
            set: `${services.notifications}/updateOptions`
        },
        rules: {
            set: `${services.notifications}/updateRule`,
            add: `${services.notifications}/addRule`,
            toggleRuleState: `${services.notifications}/toggleRuleState`,
        },
        sendTestMsg: `${services.notifications}/sendTestMessage`,
        extraRecipients: {
            get: `${services.notifications}/extraRecipients`,
            set: `${services.notifications}/updateRecipients`
        }
    },
    projectNotificationRules: {
        rules: {
            get: `${services.notifications}/projectRules`,
            delete: `${services.notifications}/deleteRule`,
        },
        rule: {
            get: `${services.notifications}/projectRule`,
        },
        neverNotifyUsers: {
            get: `${services.notifications}/getNeverNotifyUsers`,
            set: `${services.notifications}/updateNeverNotifyUsers`,
        },
        permissions: services.usermanagement.permissions
    },
    vacations: {
        get: `${services.vacations}/get`,
        save: `${ep.appRoot}Vacations/Save`,
        delete: `${ep.appRoot}Vacations/Delete`,
        getPermissions: services.usermanagement.permissions,
        getForUsers: `${services.vacations}/getForUsers`,
        export: `${services.vacations}/export`,
    },
    approvals: {
        getUnreadCount: `${services.approvals}/unreadcount`,
        getInProgressApprovals: `${services.approvals}/inprogress`,
        getHistoryApprovals: `${services.approvals}/history`,
        getApprovalsForAllocations: `${services.approvals}/allocations/getApprovers`,
    },
    rateCards: {
        get: `${services.rateCards}/getdetails`,
        save: `${services.rateCards}/save`,
        getAll: `${services.rateCards}/all`,
        getRateCards: `${services.rateCards}/getRateCards`,
        setProjectRateCard: `${services.rateCards}/setProjectRateCard`,
        setTaskRateCard: `${services.rateCards}/setTaskRateCard`,
        create: `${services.rateCards}/create`,
        copy: `${services.rateCards}/copy`,
        delete: `${services.rateCards}/delete`,
        duplicate: `${services.rateCards}/list/copy`,

        getEscalationSettings: `${services.rateCards}/escalation/get-settings`,
        updateSettings: `${services.rateCards}/escalation/update-settings`,
        escalateRatecard: `${services.rateCards}/escalation/escalate-ratecard`,
    },
    notificationCenter: {
        updateArchivedState: `${services.notifications}/notification-center/updateArchivedState`,
        eventsList: `${services.notifications}/notification-center/list`,
        newEventsCount: `${services.notifications}/notification-center/newcount`,
        markAsUnread: `${services.notifications}/notification-center/markasunread`,
    },
    finances: {
        getExpenses: (projectId, taskId) => {
            const url = `${services.finances}/expenses?projectId=${projectId}`;

            if(taskId) {
                return `${url}&taskId=${taskId}`;
            }

            return url;
        },
        getExpensesMetrics: `${services.finances}/getExpensesMetrics`,
        saveExpenseFieldValue: `${services.finances}/expenses/savefieldvalue`,
        addExpense: `${services.finances}/expenses/add`,
        byIds: `${services.finances}/expenses/byIds`,
        addAsActualExpense: `${services.finances}/expenses/addasactual`,
        deleteExpense: `${services.finances}/expenses/delete`,
        getTaskOverviewMetrics: `${services.finances}/getTaskOverviewMetrics`,
        getProjectOverviewMetrics: `${services.finances}/getProjectOverviewMetrics`,
        getProjectTargetsMetrics: `${services.finances}/getProjectTargetsMetrics`,
        getProjectMetricsBreakdown: `${services.finances}/getProjectMetricsBreakdown`,
        batchUpdate: `${services.finances}/expenses/batchupdate`,
        batchReject: `${services.finances}/expenses/batch-reject`,
        batchApprove: `${services.finances}/expenses/batch-approve`,
        getPayments: `${services.finances}/getPayments`,
        getPaymentsMetrics: `${services.finances}/getPaymentsMetrics`,
        savePaymentFieldValue: `${services.finances}/savePaymentFieldValue`,
        addPayment: `${services.finances}/addPayment`,
        deletePayment: `${services.finances}/deletePaymentNew`,
        linkAttachmentsToExpense: `${services.finances}/expenses/linkattachmentstoexpense`,
        deleteAttachment: `${services.finances}/expenses/deleteattachment`,
        exportToExcel: `${services.finances}/exportToExcel`,
        export: {
            expenses: `${services.finances}/expenses/export/csv`,
            payments: `${services.finances}/payments/export/csv`,
        },
        graphql: `${services.finances}/graphql`,
        expenseApproval: {
            getSettings: `${services.finances}/expense-approvals/get-settings`,
            saveSettings: `${services.finances}/expense-approvals/save-settings`,
            deleteSettings: `${services.finances}/expense-approvals/delete-settings`,
            getApprovers: `${services.finances}/expense-approvals/get-approvers`,
        }
    },
    attachments: {
        url: services.attachments,
        uploadFile: `${services.attachments}/api/uploadFile`,
        uploadFileAsLink: `${services.attachments}/api/uploadFileAsLink`,
        getAttachmentsInfo: `${services.attachments}/api/getAttachmentsInfo`,
        getUsageSpaceInfo: `${services.attachments}/api/getUsageSpaceInfo`,
    },
    roadmap: {
        getSharedSnapshots: `${services.roadmap}/getSharedSnapshots`,
        createSnapshot: `${services.roadmap}/createSnapshot`,
        shareSnapshot: `${services.roadmap}/shareSnapshot`,
        unshareSnapshot: `${services.roadmap}/unshareSnapshots`,
        getSharedSnapshotInfo: `${services.roadmap}/getSharedSnapshotInfo`,
        getSnapshotByKey: `${services.roadmap}/getSnapshotByKey`,
        getSnapshotUrl: accessKey => `${ensureLastSlash(ep.appRoot)}snapshots/${accessKey}`,
        v2: {
            getGanttData: `${services.roadmap}/v2/ganttData`,
            snapshots: `${services.roadmap}/v2/snapshots`,
            snapshot: id => `${services.roadmap}/v2/snapshots/${id}`,
        },
    },
    archive: {
        archiveProjects: `${services.archive}/projects/archive`,
        archiveProject: (projectId) => `${services.archive}/projects/${projectId}/archive`,
        unarchiveProject: (projectId) => `${services.archive}/projects/${projectId}/unarchive`,
        getProjects: `${services.archive}/projects`,
        getVisibleProjectNames: `${services.archive}/projects/getVisibleNames`,
        search: `${services.archive}/projects/search`,
    },
    jira: {
        getStatus: `${ep.appRoot}jira-integrations/api/v1/settings/status`,
        disconnect: `${ep.appRoot}jira-integrations/api/v1/settings`,
        configuration: `${ep.appRoot}jira-integrations/api/v1/configuration`
    },
    quickbooks: {
        authorize:(access_token) => `${services.quickbooks}/connect/authorize?access_token=${access_token}`,
        getStatus: `${services.quickbooks}/connect/status`,
        disconnect: `${services.quickbooks}/connect`,
        verifyToken: `${services.quickbooks}/connect/verify`,
        timelogsSummary: `${services.quickbooks}/export/timelogs/summary`,
        export: `${services.quickbooks}/export/timelogs/export`,
    },
    albato: {
        getToken:(bvUrl) => `${ep.appRoot}albato-integrations/api/albato/token?bvUrl=${bvUrl}`,
        getUserStatus: `${ep.appRoot}albato-integrations/api/albato/get-user-status`,
    },
    ai: {
        completion: `${services.ai}/completion`,
        generateTasks: `${services.ai}/generate/tasks`,
    },
    projectMembers: {
        addProjectMember: `${ep.appRoot}projectMembers/AddProjectMember`
    },
    spaces: {
        create: `${services.spaces}/spaces`,
        deleteMember: `${services.spaces}/members/delete`,
        updateMember: `${services.spaces}/members/update`,
        graphql: `${services.spaces}/graphql`,
        saveFieldValue: `${services.spaces}/savefieldvalue`,
        addMember: `${services.spaces}/members/add`,
        getSpacesCount: `${services.spaces}/getSpacesCount`,
        archiveSpace: `${services.spaces}/archive`,
        unarchiveSpace: `${services.spaces}/unarchive`,
        updateUsers: `${services.spaces}/members/updateUserSpaces`
    },
    invoices: {
        getProjectNamesForFilter: `${services.invoices}/getProjectNames`,
        getCustomerNamesForFilter: `${services.invoices}/getCustomerNames`,
        getNextInvoiceNumber: `${services.invoices}/getNextInvoiceNumber`,
        getDetails: `${services.invoices}/getDetails`,
        create: `${services.invoices}/create`,
        update: `${services.invoices}/update`,
        calculate: `${services.invoices}/calculate`,
        download: `${services.invoices}/download`,
        preview: `${services.invoices}/preview`,
        delete: `${services.invoices}/delete`,
        saveFieldValue: `${services.invoices}/savefieldvalue`,
        getPreviewUrl: accessKey => `${ensureLastSlash(ep.appRoot)}invoice-preview/${accessKey}`,
        previewByKey: `${services.invoices}/previewByKey`,
        downloadByKey: `${services.invoices}/downloadByKey`,
        sendEmail: `${services.invoices}/sendEmail`,
        getQuickBooksMetadata: `${services.quickbooks}/export/invoices/getQuickBooksMetadata`,
        export: `${services.quickbooks}/export/invoices/export`,
        getInvoiceAuditLog: `${services.invoices}/getInvoiceAuditLog`,
    },
    invoiceOptions: {
        get: `${services.invoiceOptions}/get`,
        update: `${services.invoiceOptions}/update`,
    },
    taxRates: {
        getAll: `${services.taxRates}/getAll`,
        saveFieldValue: `${services.taxRates}/savefieldvalue`,
        delete: `${services.taxRates}/delete`,
        create: `${services.taxRates}/create`
    }
};

ep.appUrls = appUrls;
